import { IRawStyle } from "@fluentui/react";
import React, { useState } from "react";
import { Pivot, PivotItem, Stack, WarningMessage } from "sprint-common-web";

import { CloudAssetDetailsTab, isInPreparation } from "./CloudAssetDetails";
import { useCloudAssetDetails } from "./common/hooks/useCloudAssetDetails";
import { AssetsSection } from "./sections/assets/AssetsSection";
import { InfoSection } from "./sections/info/InfoSection";
import { CloudAssetPlaybackSection } from "./sections/playback/CloudAssetPlaybackSection";

export const CloudAssetDetailsSections = (): JSX.Element => {
    const [currentTab, setCurrentTab] = useState<CloudAssetDetailsTab>(CloudAssetDetailsTab.Info);

    const { data: assetDetails } = useCloudAssetDetails();

    const shouldDisplayDvbGenerationWarning = assetDetails && isInPreparation(assetDetails);

    return (
        <Stack>
            {shouldDisplayDvbGenerationWarning && (
                <WarningMessage
                    testId="dvb-generation-warning"
                    styles={{ root: { marginBottom: 10 } }}
                    message="New proxy file is being generated for this asset. All actions are blocked until the end of processing."
                />
            )}

            <Pivot
                selectedKey={String(currentTab)}
                onLinkClick={(item) => setCurrentTab(Number(item?.props.itemKey))}
                key={String(currentTab)}
            >
                <PivotItem headerText="Info" itemKey={String(CloudAssetDetailsTab.Info)}>
                    <Stack styles={{ root: defaultStyles }}>
                        <InfoSection />
                    </Stack>
                </PivotItem>
                <PivotItem headerText="Assets" itemKey={String(CloudAssetDetailsTab.Assets)}>
                    <Stack styles={{ root: defaultStyles }}>
                        <AssetsSection />
                    </Stack>
                </PivotItem>
                <PivotItem headerText="Preview" itemKey={String(CloudAssetDetailsTab.Playback)}>
                    <Stack styles={{ root: defaultStyles }}>
                        <CloudAssetPlaybackSection />
                    </Stack>
                </PivotItem>
            </Pivot>
        </Stack>
    );
};

const defaultStyles: IRawStyle = {
    paddingTop: 20
};
